<template>
  <v-btn
      depressed
      :outlined="outlined"
      rounded
      color="primary"
      :class="classes"
      :style="style"
      @click="clicked"
  >

    <i
        v-if="iconClass.length && iconPosition === 'start'"
        :class="iconClass + (text ? ' mr-1' : '')"
    />

    <span class="eg-btn-text">{{ text }}</span>

    <i
        v-if="iconClass.length && iconPosition === 'end'"
        :class="iconClass + (text ? ' ml-1' : '')"
    />

  </v-btn>
</template>

<script>
export default {
  name: "eg-btn",
  props: {
    text: {
      type: String,
      default: ""
    },
    // Reduce paddings
    dense: {
      type: Boolean,
      default: false
    },
    // the icon class inside assets folder
    iconClass: {
      type: String,
      default: ""
    },
    // the icon position - end or start
    iconPosition: {
      type: String,
      default: "end"
    },
    // the button is outlined and background white
    outlined: {
      type: Boolean,
      default: false
    },
    // change the outlined color
    outlinedColor: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disableClickState: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isClicked: false
    }
  },
  computed: {
    style() {
      return {
        "border-color": this.outlinedColor
      };
    },
    classes() {
      return {
        "bg-orange": true,
        "eg-btn": true,
        "outlined": this.outlined,
        "border-colored": this.outlinedColor,
        "full": !this.outlined,
        "eg-disabled": this.disabled,
        "eg-btn-clicked": this.isClicked && !this.disableClickState,
        "eg-btn__dense": this.dense
      }
    }
  },
  methods: {
    clicked() {
      if (!this.disableClickState) {
        this.isClicked = true;
      }
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss">
.eg-btn {

  &.v-btn {

    &.v-size--default {
      height: unset !important;
      font-size: unset;
      padding-left: 20px !important;
      padding-right: 20px !important;
    }

    font-weight: bold;
    transition-duration: 0.3s;
    letter-spacing: unset !important;

    &:before, &:after {
      display: none;
    }
  }

  &.outlined {
    transition: border-color 0.3s, color 0.3s;

    &:hover, &.eg-btn-clicked {
      /*color: var(--v-primary-lighten1) !important;*/
      color: #999 !important;
    }

    &.border-colored:hover, &.eg-btn-clicked {
      /*border-color: var(--v-primary-lighten2) !important;*/
      border-color: #aaa !important;
    }

    &:not(.border-colored):hover, &.eg-btn-clicked {
      border-color: var(--v-primary-lighten1) !important;
    }
  }

  &.full {
    transition-property: background-color;

    &:hover, &.eg-btn-clicked {
      background-color: var(--v-primary-lighten1) !important;
    }
  }

  &.eg-btn__dense {
    padding: 0 20px !important;
    .v-btn__content {
      padding-top: 7px;
      padding-bottom: 7px;
    }
  }

  .v-btn__content {
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .eg-btn-text {
    font-size: 16px;
    line-height: 19px;
    font-weight: bold;
    /*text-transform: lowercase;*/
    font-family: Arial, sans-serif;

    &:first-letter {
      text-transform: uppercase;
    }
  }
  &.bg-white.bt-navigate{
    padding: 0 !important;
    margin-top: 1px;
    min-width: 40px !important;    
    .eg-btn-text{
      padding: 0 !important;
      margin: 0 !important;
    }
  }
  
  &.bg-green{
    .eg-btn-text{
      padding: 3px 0 0;
      font-size: 19px;
      font-weight: 500;
      font-family: 'Baloo Tamma 2', sans-serif;
    }
  }
  
  &.bt-home{
    .eg-btn-text {
      font-weight: normal;
      font-size: 22px;
      font-family: Arial, Helvetica, sans-serif;
    } 
  }
}
@media screen and (max-width: 599px) {
  .eg-btn {
    &.v-btn {
      &.bg-white.bt-navigate{
        height: 46px !important;
      }
    }
  }
}
</style>